import React, { useState, useEffect } from 'react'
import './../../assets/allRequest.css'
import DetailRequest from './DetailRequest';
import { GetallRequest }    from '../../reducers/actions/request-actions'
import { useDispatch, useSelector } from 'react-redux';
import { updateStatus, rejectRequest, cancelRequest} from "../../services/request.service";
import Paginator from './../../Components/paginator/Paginator';
import DateFilterRequest from '../../Components/filterRequest/DateFilterRequest';
import Swal from 'sweetalert2';
import { useContext } from 'react';
import { VisitorFrontendContext } from '../../context/VisitorFrontendProvider';


 const AllRequest = () => {

   const { setToken } = useContext(VisitorFrontendContext);
   const dispach = useDispatch();
   const [isOpen, setIsOpen] = useState(false);
   const [successful, setSuccessful] = useState(false);
   const [requestId, setRequestId] = useState([]);
   const [requestCurrentStatus, setRequestCurrentStatus] = useState([]);
   const [requestNumber, setRequestNumber] = useState([]);
   const [requestDescription, setrequestDescription] = useState([]);
   const [requestUserName, setRequestUserName] = useState([])
   const [requestSubject, setRequestSubject] = useState([])
   const [showRequest, setShowRequest] = useState(true);
   const [showButton, setShowButton] = useState(true);
   const [date, setDate] = useState([]);
   const [endDate, setEndDate] = useState([]);

    const [initialFilterDate, setInitialFilterDate] = useState("");
    const [finalFilterDate, setFinalFilterDate] = useState("");

   let [coments, setComent] = useState();

   const {request, status} = useSelector((state) => state.request);
   const message = useSelector((state) => state.message)
   const totalData = useSelector((state) => state.request.total);

   const { user: user } = useSelector((state) => state.auth);
   const userRoles = user?.roles;
   const isSuperAdmin = userRoles?.includes("SuperAdmin");
   const isApprover = userRoles?.includes("Approver");
   const isClient = userRoles?.includes("Client");

   const [currentPage, setCurrentPage] = useState(1);
   const [dataPerPage] = useState(6);

   const paginate = (pageNumber) => {
     setCurrentPage(pageNumber);
     if(pageNumber > 0){
       dispach(GetallRequest(dataPerPage, pageNumber));
       if (status === 200) {
         setToken(true);
       } else {
         setToken(false);
       }
     }
   };

   useEffect(() => {
     dispach(GetallRequest(dataPerPage, currentPage));
     if(status === 200){
      setToken(true)
     }else{
      setToken(false)
     }
   }, []);

    useEffect(() => {
      request.map(item => {
       if(item.currentStatus === 'Canceled'){
         setShowButton(false);
       }else{
         setShowButton(true);
       }
      })
    })

   const currentStatus = {
     ["OnApprovation"]: "En aprobacion.",
     ["Approved"]: "Aprobado",
     ["Rejected"]: "Rechazado",
     ["Created"]: "Creado",
     ["Imcomplete"]: "Incompleto",
     ["Completed"]: "Completado",
     ["Canceled"]: "Anulada"
   };

   const handleInputChange = (e) => {
    setComent(e.target.value);
  }

  const showAlert = (adMesagge, suMessage, solMesage, cancelMessage, handleFunction) => {
    Swal.fire({
      title: "Advertencia",
      text: adMesagge,
      icon: "info",
      showDenyButton: true,
      denyButtonText: "No",
      confirmButtonText:"Si",
      confirmButtonColor: "#3085d6",
    }).then(response => {
      if(response.isConfirmed){
        Swal.fire({
          title: solMesage,
          text: suMessage,
          icon: "success",
          confirmButtonText:"Ok",
          confirmButtonColor: "#3085d6",
        })
        handleFunction();
      }else{
        Swal.fire({
          title: "Cancelado",
          text: cancelMessage,
          icon: "error",
          confirmButtonText:"Ok",
          confirmButtonColor: "#3085d6",
        })
      }
    });
  }

   const handleSubmitAprove = () => {
    setSuccessful(false);
    dispach(updateStatus(requestId, coments))
      .then(() => {
        setSuccessful(true);
      })
      .catch(() => {
        setSuccessful(false);
      });
  }

  const handleSubmitReject = () => {
    setSuccessful(false);
    dispach(rejectRequest(requestId, coments))
      .then(() => {
        setSuccessful(true);
      })
      .catch(() => {
        setSuccessful(false);
      });
  }

  const handleCancelRequest = () => {
    setSuccessful(false);
    dispach(cancelRequest(requestId))
      .then(() => {
        setSuccessful(true);
      })
      .catch(() => {
        setSuccessful(false);
      });
  }



  const onFilterValueChanged = (e) => {
    setCurrentPage(1);
    dispach(GetallRequest(dataPerPage, currentPage ,e.target.value));
  }

  const submitChange = () => {
    setCurrentPage(1);
      dispach(
        GetallRequest(
          dataPerPage,
          currentPage,
          "",
          initialFilterDate,
          finalFilterDate
        )
      );
  }
  

  const onInitialDateChange = (e) => {
    const date = e.target.value;
    setInitialFilterDate(date);
    if(date != ""){
      submitChange();
    }
  }

  const onFinalDateChange = (e) => {
    const date = e.target.value;
    setFinalFilterDate(date);
    if(date != ""){
      submitChange();
    }
  }

   return (
     <div className="container">
       <div className={`row g-3`}>
         <div className={`${showRequest ? "show-request" : "no-show-request"}`}>
           {request ? (
             <Paginator
               dataPerPage={dataPerPage}
               totalData={totalData}
               paginate={paginate}
               currentPage={currentPage}
             />
           ) : (
             ""
           )}
           <DateFilterRequest
             onFirstDateValueChange={onInitialDateChange}
             onSecondDateValueChange={onFinalDateChange}
             onFilterValueChanged={onFilterValueChanged}
           />
         </div>
         <div className="mobile-content-display">
           <ul
             className={`list-group ${
               showRequest ? "show-request" : "no-show-request"
             }`}
           >
             <ul className="list-group-item list-group-item-action d-none d-lg-inline-block border-bottom ul-request">
               <div className="row">
                 <div className="col-lg list-request-title">
                   <strong>Solicitud</strong>
                 </div>
                 <div className="col list-request-title">
                   <strong>Asunto</strong>
                 </div>
                 <div className="col list-request-title">
                   <strong>Visitante</strong>
                 </div>
                 <div className="col list-request-title">
                   <strong>Empresa</strong>
                 </div>
                 <div className="col list-request-title">
                   <strong>Fecha</strong>
                 </div>
                 <div className="col list-request-title">
                   <strong>Estado</strong>
                 </div>
               </div>
             </ul>

             {request &&
               request?.map((request, index) =>
                 ((isSuperAdmin || isApprover) && request.currentStatus == "Canceled") ? (
                   ""
                 ) : (
                   <a
                     onClick={() => (
                       setIsOpen(true),
                       setRequestId(request.id),
                       setRequestCurrentStatus(request.currentStatus),
                       setrequestDescription(request.requestDescription),
                       setDate(request.allInitialDate),
                       setRequestUserName(request.requestUserName),
                       setEndDate(request.allFinalDate),
                       setRequestNumber(request.requestNumber),
                       setRequestSubject(request.subject),
                       setShowRequest(false)
                     )}
                     className={`list-group-item list-group-item-action ul-request ${
                       showRequest ? "show-request" : "no-show-request"
                     } ul-request`}
                     key={index}
                   >
                     <div className="row">
                       <div className="col-2 list-request-title">
                         <strong>{`#${request.requestNumber}`}</strong>
                       </div>
                       <div className="col-6 col-lg">
                         <small className="d-lg-none mt-1">
                           Show
                           <br />
                         </small>
                         {`${request.subject}`}
                       </div>
                       <div className="col-6 col-lg">
                         <small className="d-lg-none mt-1">
                           Played By
                           <br />
                         </small>
                         {`${request.requestUserName}`}
                       </div>
                       <div className="col-6 col-lg">
                         <small className="d-lg-none mt-1">
                           Played By
                           <br />
                         </small>
                         {`${request.companyName}`}
                       </div>
                       <div className="col-6 col-lg">
                         {`Fecha ingreso: ${request.allInitialDate}. Fecha Salida: ${request.allFinalDate}.`}
                       </div>
                       <div className="col-6 col-lg">
                         <span className="d-lg-none">Rating: </span>
                         {`${currentStatus[request.currentStatus]}`}
                       </div>
                     </div>
                   </a>
                 )
               )}
           </ul>
         </div>
         {request?.map((oneRequest) => (
           <div
             key={oneRequest.id}
             className={`col-lg-4 mobile-content ${
               showRequest ? "show-request" : "no-show-request"
             }`}
           >
             <div className="card card-margin h-100">
               <div className="card-header no-border">
                 <h5 className="card-title">{`Solicitud #${oneRequest.requestNumber}`}</h5>
               </div>
               <div className="card-body pt-0">
                 <div className="widget-49">
                   <div className="widget-49-title-wrapper">
                     <div className="widget-49-date-primary">
                       <span className="widget-49-date-day">
                         {oneRequest.day}
                       </span>
                       <span className="widget-49-date-month">
                         {oneRequest.month}
                       </span>
                       <span className="widget-49-date-year">
                         {oneRequest.year}
                       </span>
                     </div>
                     <div className="widget-49-meeting-info">
                       <span className="widget-49-pro-title">
                         {oneRequest.subject}
                       </span>
                       <span className="widget-49-meeting-time">{`Estado de la solicitud: ${
                         currentStatus[oneRequest.currentStatus]
                       }`}</span>
                     </div>
                   </div>
                   <ul className="widget-49-meeting-points">
                     {(isSuperAdmin || isApprover) && (
                       <li className="widget-49-meeting-item">
                         <span>{`Funcionario al que visita: ${oneRequest.userApproverName}`}</span>
                       </li>
                     )}
                     <li className="widget-49-meeting-item">
                       <span>{`Compañía que visita: ${oneRequest.companyName}`}</span>
                     </li>
                     <li className="widget-49-meeting-item">
                       <span>{`Fecha de ingreso: ${oneRequest.allInitialDate}`}</span>
                     </li>
                     <li className="widget-49-meeting-item">
                       <span>{`Fecha de salida: ${oneRequest.allFinalDate}`}</span>
                     </li>
                   </ul>

                   {(isSuperAdmin || isApprover) && (
                     <div>
                       <form>
                         <label
                           htmlFor="comments"
                           className="form-label"
                           style={{ fontSize: "18px", paddingLeft: "12px" }}
                         >
                           <span className="text-span">Comentarios:</span>
                         </label>
                         <div className="mb-3 row">
                           <div className="col-sm-12">
                             <textarea
                               style={{ paddingLeft: "14px" }}
                               name="comments"
                               className="form-control"
                               rows={2}
                               defaultValue={""}
                               onChange={handleInputChange}
                             />
                           </div>
                         </div>
                       </form>
                       <div className="widget-49-meeting-action">
                         <button
                           className="btn btn-success btn-sm"
                           onClick={() => {
                             setRequestId(oneRequest.id);
                             showAlert(
                               "Confirma aprobar la solicitud?",
                               "",
                               `la solicitud #${oneRequest.requestNumber} ha sido aprobada`,
                               `Se cancelo aprobar la solicitud`,
                               handleSubmitAprove
                             );
                           }}
                         >
                           <i className="bi bi-check"> Aprobar</i>
                         </button>
                         <button
                           className="btn btn-danger btn-sm"
                           onClick={() => {
                             setRequestId(oneRequest.id);
                             showAlert(
                               "Confirma rechazar la solicitud?",
                               "",
                               `la solicitud #${oneRequest.requestNumber} ha sido rechazada`,
                               `Se cancelo rechazar la solicitud`,
                               handleSubmitReject
                             );
                           }}
                         >
                           <i className="bi bi-x"> Rechazar</i>
                         </button>
                         <button
                           className="btn btn-primary btn-sm"
                           onClick={() => (
                             setIsOpen(true),
                             setRequestId(oneRequest.id),
                             setRequestCurrentStatus(oneRequest.currentStatus),
                             setrequestDescription(
                               oneRequest.requestDescription
                             ),
                             setDate(oneRequest.allInitialDate),
                             setEndDate(oneRequest.allFinalDate),
                             setRequestNumber(oneRequest.requestNumber),
                             setRequestSubject(oneRequest.subject),
                             setShowRequest(false)
                           )}
                         >
                           <i className="bi bi-eye"> Ver detalle</i>
                         </button>
                       </div>
                     </div>
                   )}
                   {isClient && (
                     <div className="widget-49-meeting-action">
                       <button
                         className="btn btn-primary btn-sm"
                         onClick={() => (
                           setIsOpen(true),
                           setRequestId(oneRequest.id),
                           setRequestCurrentStatus(oneRequest.currentStatus),
                           setDate(oneRequest.allInitialDate),
                           setrequestDescription(oneRequest.requestDescription),
                           setRequestNumber(oneRequest.requestNumber),
                           setRequestSubject(oneRequest.subject),
                           setShowRequest(false)
                         )}
                       >
                         <i className="bi bi-eye"> Ver detalle</i>
                       </button>
                       <button
                         className={`btn btn-danger btn-sm ${
                           showButton ? "show-button" : "no-show-button"
                         }`}
                         onClick={() => {
                           setRequestId(oneRequest.id);
                           showAlert(
                             "Confirma anular la solicitud?",
                             "",
                             `la solicitud #${oneRequest.requestNumber} ha sido anulada`,
                             `Se cancelo rechazar la solicitud`,
                             handleCancelRequest
                           );
                         }}
                       >
                         <i className="bi bi-x">Anular solicitud</i>
                       </button>
                     </div>
                   )}
                 </div>
               </div>
             </div>
           </div>
         ))}
         {isOpen && (
           <DetailRequest
             setIsOpen={setIsOpen}
             requestId={requestId}
             requestTitle={requestSubject}
             requestCurrentStatus={requestCurrentStatus}
             requestFinalDate={endDate}
             requestInitialDate={date}
             description={requestDescription}
             requestNumber={requestNumber}
             requestUserName={requestUserName}
             setShowRequest={setShowRequest}
           />
         )}
       </div>
     </div>
   );
 }

export default AllRequest